<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/d5smTe/tc-custom/9781035831357.jpg?1712387810832" alt="This image is the cover for the book Who Will Bury The Dead God?"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Who Will Bury The Dead God?
      </h1>
      <p class="bookDescription body article font2">
        <p>Imagine a man straddling both sides of good and evil, struggling to regain his balance. He clutches onto both aspects with his bewildered mind, pondering his own senses. As he stands there, his mind races with questions. What is the meaning of his existence? Why has he been placed in this moment, at this time, with these thoughts and feelings? Is there a purpose to his life, or is it all just a random series of events? ‘I know God smells terribly bad, and I’m ready to bury him deep in the ground. But is this really the right thing to do? Is there a better solution? Should I try to make the smell more bearable, or is this the only course of action? I’m torn between doing what’s best for God and the reality of the situation,’ he thinks. Has he fallen into the river of dilemma and been washed away from his suffering? Will this man unravel the mystery of his existence, or will he be swallowed up by the abyss of his own mind?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ruman Neupane
      </h2>
      
      <p class="authorDescription body article">Ruman Neupane was born in Bhaktapur, Nepal, a medieval town founded in the 12th century. Currently, he resides in Australia with his wife, Pratiksha, and son, Ryan. He is an avid reader and writer who is deeply influenced by Nietzschean philosophy. He is particularly drawn to the pessimistic style of Schopenhauerian writing, which he believes accurately reflects the human condition. Ruman has previously published two books, both of which were well received by readers and critics. This book is his third, and he hopes that it will be just as well received as his previous works. In his writing, Ruman combines elements of Hindu and Greek mythology to create a unique and compelling narrative. He is deeply interested in the philosophical dynamics of Hinduism, and this is reflected in his writing. His taste in music is eclectic, but he is a core follower of The Doors and Freddie Mercury.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?12f403f0